import request from "../utils/request";

export function getCustomers(params) {
    return request({
        url: "customers",
        method: "get",
        params,
    });
}

export function getCustomer(id) {
    return request({
        url: `customers/${id}`,
        method: "get",
    });
}

export function addCustomer(data) {
    return request({
        url: "customers",
        method: "post",
        data,
    });
}

export function updateCustomer(id, data) {
    return request({
        url: `customers/${id}`,
        method: "put",
        data,
    });
}

export function updateCustomerWithDocuments(id, formData, progress = undefined) {
    return request({
        url: `customers/${id}`,
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
            if (progress !== undefined && progressEvent.lengthComputable) {
                progress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
            }
        },
        data: formData,
    });
}

export function deleteCustomer(id) {
    return request({
        url: `customers/${id}`,
        method: "delete",
    });
}
